import { type UserInfo } from "@repo/api";

export const getUserInfoFromEmail = (emailId: string | undefined): UserInfo => {
  return {
    emailId: emailId ?? "",
  };
};
